var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-margin-top-50" }, [
    _vm.loaders.courses
      ? _c(
          "div",
          { staticClass: "loading-indicator" },
          [_c("MoonLoader", { attrs: { size: "75px", color: "#ffffff" } })],
          1
        )
      : _c("div", { staticClass: "library__group h-center-align" }, [
          _c(
            "div",
            { staticClass: "library__collection" },
            [
              _vm._l(_vm.courses, function(course, index) {
                return _c("CourseCard", {
                  key: index,
                  attrs: { course: course }
                })
              }),
              _vm._v(" "),
              _c("CourseModal", { attrs: { "modal-key": "courseModal" } })
            ],
            2
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }